import React, { useEffect, useState } from 'react'
import { Box, Collapse, Grid, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import * as yup from 'yup'
import { useDispatch } from 'react-redux'
import { FormProps } from '../../../../types/default-types'
import { CheckboxInput, Modal, Snackbar, SubmitButton, TextInput, validation } from '../../../../components'

import { post } from '../../../../api'
// eslint-disable-next-line import/no-cycle
import { CommandRequestThreeStage } from '../../accordions'
import { modalsAction } from '../../../../store/modals'

const schema = validation({
  team: yup.string().required().max(20),
})

export const CreateTeamsThreeStageModal: React.FC<{
  request: CommandRequestThreeStage | undefined
  onClose: () => void
}> = ({ request, onClose = () => {} }): JSX.Element => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const hookForm = useForm<any>({
    defaultValues: { team: '' },
    resolver: yupResolver(schema),
    mode: 'onBlur',
  })

  const [formProps, setFormProps] = useState<FormProps<any>>({
    data: undefined,
    processed: false,
    snackbar: {
      onClose: () => reserError,
    },
  })

  const reserError = () => {
    setFormProps({ ...formProps, snackbar: { ...formProps.snackbar, message: undefined } })
  }

  const [collapse, setCollapse] = useState<boolean>(true)
  const [step, setStep] = useState<number>(1)
  const [command, setCommand] = useState<any>()

  const onCloseModal = () => {
    onClose()
    setCollapse(false)
    setCommand(undefined)
    setStep(1)
    hookForm.reset()
    reserError()
  }

  const back = () => {
    setStep(1)
    setCommand(undefined)
    reserError()
  }

  const save = () => {
    post('/private/commands/v2/create', command).then(({ status = 0, message: messages }) => {
      if (status === 1) {
        dispatch(
          modalsAction.alert({
            message: messages,
            onClose: () => {
              onClose()
              setStep(1)
              setCommand(undefined)
            },
          })
        )
      } else {
        setFormProps({
          ...formProps,
          processed: false,
          snackbar: { ...formProps.snackbar, message: messages },
        })
      }
    })
  }

  const onSubmitForm = (data: { team: string; r: any[] }) => {
    reserError()
    const req: number[] = []
    data.r.forEach((i, k) => {
      if (i === true) req.push(k)
    })

    if (req.length !== 4) {
      setFormProps({
        ...formProps,
        processed: false,
        snackbar: { ...formProps.snackbar, message: { error: ['Команда должна состоять из 4 человек'] } },
      })
    } else {
      setCommand({ name: data.team, requests: req, nomination_id: request?.nomination.id })
      setStep(2)
    }
  }

  useEffect(() => {
    if (!collapse) {
      setTimeout(() => setCollapse(true), 200)
    }
  }, [collapse])

  const check = {
    icon: <span className={classes.icon} />,
    checked: (
      <span className={classes.icon}>
        <Box className={classes.check} />
      </span>
    ),
  }

  return (
    <Modal
      open={request !== undefined}
      maxWidth="sm"
      title="Создать команду"
      onClose={onCloseModal}
      className={classes.modal}
    >
      {step === 1 && (
        <Collapse in={collapse}>
          <Box textAlign="center">«{request?.nomination.name}»</Box>
          <Box mt={3}>
            <form onSubmit={hookForm.handleSubmit(onSubmitForm)} autoComplete="off" noValidate>
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={8}>
                  <Box width="100%" height={80}>
                    <TextInput
                      variant="filled"
                      name="team"
                      label="Название"
                      placeholder="Введите название команды"
                      form={hookForm}
                      disabled={formProps.processed}
                    />
                  </Box>

                  {request?.users.map((i) => {
                    return (
                      <Box textAlign="left" mb={3}>
                        <CheckboxInput
                          name={`r.${i.id}`}
                          color="secondary"
                          label={i.full_name}
                          icon={check.icon}
                          checked={check.checked}
                          form={hookForm}
                        />
                      </Box>
                    )
                  })}
                </Grid>
              </Grid>
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={8}>
                  <Snackbar {...formProps.snackbar} variantMessage="error" />
                </Grid>
              </Grid>
              <Box width="100%" maxWidth={200} mx="auto" mt={2} mb={3}>
                <SubmitButton
                  fullWidth
                  disabled={formProps.processed}
                  processed={formProps.processed}
                  title="Продолжить"
                  className={classes.btn}
                />
              </Box>
            </form>
          </Box>
        </Collapse>
      )}
      {step === 2 && (
        <Collapse in={collapse}>
          <Box mt={3}>
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={10}>
                <Box width="100%" textAlign="center" fontSize={20} fontWeight={600}>
                  Команда «{request?.nomination.name}»: <b style={{ color: '#E21222' }}>{command.name}</b>
                </Box>
                <Box pt={1} fontSize={15}>
                  <ul>
                    {/* eslint-disable-next-line array-callback-return */}
                    {request?.users.map((y: any) => {
                      return (
                        <>
                          {/* eslint-disable-next-line array-callback-return,consistent-return */}
                          {command?.requests.map((i: any) => {
                            /* eslint-disable-next-line array-callback-return,consistent-return */
                            if (y.id === i) {
                              return <li style={{ paddingTop: 5 }}>{y.full_name}</li>
                            }
                          })}
                        </>
                      )
                    })}
                  </ul>
                </Box>
              </Grid>
            </Grid>
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={8}>
                <Snackbar {...formProps.snackbar} variantMessage="error" />
              </Grid>
            </Grid>
            <Box width="100%" maxWidth={300} mx="auto" mt={3}>
              <Box>
                <SubmitButton
                  fullWidth
                  disabled={formProps.processed}
                  processed={formProps.processed}
                  title={`Создать команду «${request?.nomination.name}»`}
                  className={classes.btn}
                  onClick={save}
                />
              </Box>
              <Box pt={2}>
                <SubmitButton
                  fullWidth
                  type="button"
                  disabled={formProps.processed}
                  processed={formProps.processed}
                  title="Назад"
                  onClick={back}
                  className={classes.btn2}
                />
              </Box>
            </Box>
          </Box>
        </Collapse>
      )}
    </Modal>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  modal: {
    '& .MuiDialogTitle-root': {
      fontSize: '24px!important',
      paddingLeft: '40px!important',
      paddingRight: '40px!important',
      [down('sm')]: {
        fontSize: '22px!important',
        paddingLeft: '40px!important',
        paddingRight: '40px!important',
      },
    },
    '& .MuiFormControlLabel-root .MuiTypography-root': {
      fontSize: '15px!important',
      fontWeight: '600!important',
      color: `${palette.text.secondary}!important`,
      [down('sm')]: {
        fontSize: '14px!important',
      },
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
  },
  btn2: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    backgroundColor: 'rgba(120,120,120, .7)!important',
  },
  icon: {
    width: 10,
    height: 10,
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    border: `3px solid ${palette.primary.dark}`,
  },
  check: {
    borderRadius: 50,
    width: 10,
    height: 10,
    backgroundColor: ` ${palette.secondary.main}`,
  },
}))
